// --- Reusable helpers ---
const _comp32Serializer = new XMLSerializer();
let _comp32HiddenTA;

const _comp32GetTA = () => {
    if (!_comp32HiddenTA) {
        _comp32HiddenTA = document.createElement("textarea");
        Object.assign(_comp32HiddenTA.style, {
            position: "fixed",
            opacity: "0",
            pointerEvents: "none",
            zIndex: "-1",
            top: "0",
            left: "0",
            width: "1px",
            height: "1px",
        });
        document.body.appendChild(_comp32HiddenTA);
    }
    return _comp32HiddenTA;
};

const _comp32Copy = async (text) => {
    if (navigator.clipboard && window.isSecureContext) {
        try {
            await navigator.clipboard.writeText(text);
            return true;
        } catch {}
    }
    const ta = _comp32GetTA();
    ta.value = text;
    ta.select();
    try {
        return document.execCommand("copy");
    } finally {
        ta.blur();
    }
};

function Comp32() {
    const ROOT = ".comp-32";
    const ITEM = ".comp-32-slider .comp-32-slider-icon";

    const esc = (id) =>
        window.CSS && CSS.escape ? `#${CSS.escape(id)}` : `#${id}`;

    const findSVG = ($item, id) => {
        const sel = esc(id);
        let el = $item.find(sel).get(0) || $item.closest(ROOT).find(sel).get(0);
        if (!el) return null;
        if (el.tagName.toLowerCase() !== "svg") el = el.querySelector("svg");
        return el || null;
    };

    $(document)
        .off("click.comp32", ITEM)
        .on("click.comp32", ITEM, async (e) => {
            const id = e.currentTarget.dataset.target;
            if (!id) return;

            const svg = findSVG($(e.currentTarget), id);
            if (!svg) return;

            const node = svg.cloneNode(true);
            node.hasAttribute("xmlns") ||
                node.setAttribute("xmlns", "http://www.w3.org/2000/svg");

            if (
                !node.hasAttribute("xmlns:xlink") &&
                (node.hasAttribute("xlink:href") ||
                    node.querySelector("[xlink\\:href]"))
            ) {
                node.setAttribute(
                    "xmlns:xlink",
                    "http://www.w3.org/1999/xlink"
                );
            }

            if (
                (!node.getAttribute("width") || !node.getAttribute("height")) &&
                node.hasAttribute("viewBox")
            ) {
                const [, , w, h] = node
                    .getAttribute("viewBox")
                    .split(/\s+/)
                    .map(Number);
                node.getAttribute("width") || node.setAttribute("width", w);
                node.getAttribute("height") || node.setAttribute("height", h);
            }

            const svgText = _comp32Serializer.serializeToString(node);
            if (!svgText) return;

            if (await _comp32Copy(svgText)) {
                const a = document.querySelector(".copied-alert.svg");
                a?.classList.add("show");
                setTimeout(() => a?.classList.remove("show"), 2000);
            }
        });

    var swiper = new Swiper(".comp-32 .comp-32-slider .swiper", {
        slidesPerView: 12,
        slidesPerGroup: 12,
        spaceBetween: 0,
        speed: 600,
        autoplay: {
            delay: 4000,
            disableOnInteraction: false,
        },
        grid: {
            rows: 3,
        },

        pagination: {
            el: ".comp-32 .comp-32-slider .swiper-pagination",
            clickable: true,
        },
    });
}
Comp32();
